import type { ClientFormValues } from '../models/Forms';

export type AddressValuesForFingerprint = Pick<ClientFormValues, 'street' | 'streetNumber' | 'city' | 'psc' | 'state'>;

export function getAddressValidationFingerprint(values: AddressValuesForFingerprint): string {
  return JSON.stringify({
    street: values.street?.trim() ?? '',
    streetNumber: values.streetNumber?.trim() ?? '',
    city: values.city?.trim() ?? '',
    psc: values.psc?.trim() ?? '',
    state: values.state?.trim() ?? '',
  });
}

export function isAddressValidationCompletedStatus(status: ClientFormValues['addressValidationStatus']): boolean {
  return status === 'validated' || status === 'user_override' || status === 'unverified';
}

export function hasCompletedAddressValidationForFingerprint(
  values: Pick<ClientFormValues, 'psc' | 'addressValidationStatus'>,
  fingerprint: string,
  lastValidatedFingerprint: string | undefined,
): boolean {
  if (!values.psc?.trim() || !isAddressValidationCompletedStatus(values.addressValidationStatus)) {
    return false;
  }
  return lastValidatedFingerprint === fingerprint;
}
